/**
 * Phase 7.2 download helpers — trigger browser-side blob downloads while
 * preserving Authorization headers (which a plain `<a href>` cannot carry).
 *
 * Usage:
 *   import { api } from "./api";
 *   import { downloadBlob, downloadFromApi } from "./downloads";
 *
 *   await downloadFromApi("/certificates/abc/pdf", "freddy.pdf");
 *   // or, if you already have a Blob:
 *   downloadBlob(myBlob, "filename.pdf");
 */
import { api } from "./api";

/**
 * Triggers a download of a Blob via a temporary <a> tag. Works in all major
 * browsers. Caller is responsible for picking the filename.
 */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  // Some browsers require the anchor to be in the DOM
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Give the click a tick before revoking so Safari doesn't choke
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

/**
 * GET a path with `responseType: blob`, honour `Content-Disposition` for the
 * filename when present, fall back to the supplied `defaultFilename`.
 */
export async function downloadFromApi(path, defaultFilename) {
  const res = await api.get(path, { responseType: "blob" });
  let filename = defaultFilename || "download";
  const cd = res.headers?.["content-disposition"] || res.headers?.["Content-Disposition"];
  if (cd) {
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
    if (match && match[1]) filename = decodeURIComponent(match[1]);
  }
  downloadBlob(res.data, filename);
}
